export default function Footer() {
  return (
    <footer className="bg-[#000000] py-12 md:py-16 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Logo 與品牌名稱 */}
        <div className="flex flex-col items-center justify-center mb-6">
          <div className="mb-3">
            <img 
              src="https://static.readdy.ai/image/ac888b511a221428483efbe2f4452036/52062b15afd5a25e63638b57c5108876.png" 
              alt="全鏈獲客整合行銷 Logo" 
              className="h-12 md:h-14 w-auto"
            />
          </div>
          <div className="text-lg md:text-xl font-bold text-white text-center">
            全鏈獲客整合行銷
          </div>
        </div>

        <p className="text-white/50 text-xs sm:text-sm text-center mb-6 max-w-2xl mx-auto px-4">
          影音引流 × 系統建站 × 自動化轉換，為您打造永不休假的營收生產線。
        </p>
        
        {/* 分隔線 */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mb-6"></div>
        
        {/* 版權與連結 */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-5">
          <p className="text-white/40 text-xs sm:text-sm text-center">
            © 2026 全鏈獲客整合行銷. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 text-xs sm:text-sm hover:text-[#00D4FF] transition-colors cursor-pointer">
              隱私權政策
            </a>
            <a href="#" className="text-white/40 text-xs sm:text-sm hover:text-[#00D4FF] transition-colors cursor-pointer">
              服務條款
            </a>
          </div>
        </div>

        {/* 聯絡信箱 */}
        <div className="text-center">
          <a 
            href="mailto:fullchainmarketing@gmail.com" 
            className="inline-flex items-center gap-2 text-white/50 text-xs sm:text-sm hover:text-[#00D4FF] transition-colors cursor-pointer"
          >
            <i className="ri-mail-line"></i>
            <span>fullchainmarketing@gmail.com</span>
          </a>
        </div>
      </div>
    </footer>
  );
}